import { Editor } from '@tinymce/tinymce-react';
import { FC, useRef, useState } from 'react';
import { useLocalStorageSimple } from '../../hooks/useLocalStorage'

import { PagesApi } from '../../api/payment-and-delivery';
import { useUser } from '../../hooks/useUser';
import { CustomButton } from '../Button';

interface IEditor {
  initialValue: string;
  type: 'payment' | 'for-organizations' | 'o-proekte' | 'articles';
}
export const CustomEditor: FC<IEditor> = ({ initialValue, type }) => {
  //Редактор HTML
  const editorRef = useRef(null);
  //Отредактирована страница
  const [isChanged, setIsChanged] = useState(false);
  //Начальное значение редактора HTML
  const { loggedIn, super_admin } = useUser();
  // Добавить/Получить токен
  const [sessionToken, setSessionToken] = useLocalStorageSimple('st', '');
  //Отредактировано в редакторе
  const handleEditorChange = (editor_content: any, editor: any) => {
    setIsChanged(true);
  };

  //Сохранение страницы
  const savePage = async () => {
    //Дополнительная проверка на то что пользователь авторизован и супер адмен
    if (loggedIn && super_admin) {
      let cur_content: string = '';
      if (editorRef.current) {
        cur_content = (editorRef.current as any).getContent();
      }
      await PagesApi().setSave(type, cur_content, sessionToken);
    } else {
      alert('У вас не прав на редактирование статей');
    }
  };

  let html;
  //Если админ, показываем inline редактор, иначе просто html
  //super_admin возвращает /api/admin/check-login
  //Визуальный редактор TinyMCE

  html = (
    <>
      <input
        id="imgFile"
        type="file"
        style={{ display: 'none' }}
        name="imgFile"
        accept="image/*"
      />

      <Editor
        tinymceScriptSrc="/tinymce/tinymce.min.js"
        onInit={(evt: any, editor: any) => (editorRef.current = editor)}
        initialValue={initialValue}
        disabled={loggedIn && super_admin ? false : true}
        init={{
          height: 500,
          language: 'ru',
          menubar: true,
          inline: true,
          promotion: false,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'charmap',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'preview',
            'help',
            'wordcount',
            'image',
          ],
          toolbar:
            'undo redo | blocks | ' +
            'bold italic forecolor backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'image | ' +
            'removeformat | help',
          content_style:
            'body { padding: 5px; font-family:Helvetica,Arial,sans-serif; font-size:14px }',
          a11y_advanced_options: true,
          /* enable title field in the Image dialog*/
          image_title: true,
          /* enable automatic uploads of images represented by blob or data URIs*/
          /*automatic_uploads пока не используется, т.к. проблемы с редактором на фронте (страница сама перезагружается после вставки картинки)
          Поэтому картинки сейчас сохраняются прямо в html в base64 формате
          */
          automatic_uploads: false,
          /*
            URL of our upload handler (for more details check: https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_url)
            here we add custom filepicker only to Image dialog
          */
          images_upload_url:
            process.env.REACT_APP_BASE_URL_API + '/upload_file',
          file_picker_types: 'image',
          /* and here's our custom image picker*/
          file_picker_callback: (cb, value, meta) => {
            if (meta.filetype == 'image') {
              var input_el = document.getElementById('imgFile');
              if (input_el != null) {
                input_el.addEventListener('change', (e: any) => {
                  const file = e.target.files[0];

                  const reader = new FileReader();
                  reader.addEventListener('load', () => {
                    /*
                      Note: Now we need to register the blob in TinyMCEs image blob
                      registry. In the next release this part hopefully won't be
                      necessary, as we are looking to handle it internally.
                    */
                    const id = 'blobid' + new Date().getTime();
                    //const blobCache =  (window as any).tinymce.activeEditor.editorUpload.blobCache;
                    const blobCache = (editorRef.current as any).editorUpload
                      .blobCache;
                    if (reader.result != null) {
                      const base64 = (reader.result as any).split(',')[1];
                      const blobInfo = blobCache.create(id, file, base64);
                      blobCache.add(blobInfo);

                      /* call the callback and populate the Title field with the file name */
                      cb(blobInfo.blobUri(), { title: file.name });
                    }
                  });
                  reader.readAsDataURL(file);
                });

                input_el.click();
              }
            }
          },
        }}
        onEditorChange={handleEditorChange}
      />
    </>
  );
  return (
    <>
      {loggedIn && super_admin ? (
        <div>{html}</div>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: initialValue }} />
      )}
      {loggedIn && super_admin && isChanged && (
        <div style={{ width: 200, marginTop: 16 }}>
          <CustomButton variant="orange" onClick={savePage}>
            Сохранить
          </CustomButton>
        </div>
      )}
    </>
  );
};
